import { render, staticRenderFns } from "./DbMappingInTableFilter.vue?vue&type=template&id=cf72b620"
import script from "./DbMappingInTableFilter.vue?vue&type=script&lang=js"
export * from "./DbMappingInTableFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports